<template>
  <div class="wrapper-card">
    <div class="card col-md-6">
        <h3>Nașterea pe cale naturală</h3>
        <p>este de preferat nașterii prin cezariană pentru că bebelușul preia prin canalul vaginal bacteriile bune. Acestea au grijă ca flora intestinală să rămână echilibrată.</p>
    </div>
  </div>
</template>

<script>

export default {
    name: 'NastereNaturala',
    data() {
        return {}
    },
}
</script>
<style scoped lang="scss">
.bk-blue-light {
    background: #F2F0ED;
    border-radius: 20px;
    width: 458px !important;
    min-height: 200px;
    max-height: 200px;
    position: relative;
    @media only screen and (max-width: 992px) {
        width: 100% !important;
        min-height: 100%;
        max-height: 100%;
        margin-top: 15px;
    }

    &:focus {
        outline: none;
    }

    h3 {
        font-size: 20px;
        font-weight: 700;
        color: #029FE3;
    }

    p {
        font-size: 14px;
        font-weight: 500;
        color: #029FE3;
    }

    span {
        font-size: 16px;
        font-weight: 500;
        color: #029FE3;
    }
}
</style>
